export default {
    accessDenied: 'Access Denied',
    objectNotFound: 'Object Not Found',
    tagCreationFailed: 'Tag creation failed',
    errorWhileParsingFile: 'There was an error while parsing the file',
    mfaCodeWrong: 'The given code was wrong, please try again',
    "Couldn't connect to server": "Couldn't connect to server",
    mustBeValueBetween: 'The value must be between {min} and {max}',
    metaSetName: 'The meta set cannot start with "sfx." because this is a protected namespace',
    PleaseSelectTheFormatOfYourMetaFile: 'Please select the format of your meta file or remove the meta file (adding meta data only works for the given formats)',
    PleaseSelectARootNode: 'Please select a root node for the given 3D-Data',
    alreadyExists: 'Duplicate name: There exists already a {type} with this name',
    metaSetNameAlreadyExists: 'Duplicate name: There exists already a meta set with this name',
    textNameAlreadyExists: 'Duplicate name: There exists already an asset with this name',
    connectionLimit: 'Only {num} elements can be linked for this content type. Please unlink one or more elements before linking a new one.',
    linkingNotPossible: 'The content could not be linked, there was an error.',
    cantEditRowWhenData: 'Fields cannot be edited if there are data rows containing data.',
    mustbeanumber: 'The value must be a number',
    atLeastCharacters: 'Please enter at least {num} characters',
    duplicateNameForAsset: 'Duplicate name: There exists already an asset with this name',
    duplicateNameForReport: 'Duplicate name: There exists already an report with this name',
    atLeastThreeCharacters: 'Please enter at least 3 characters',
    userNameAlreadyExists: 'A user with this name already exists, please choose another name',
    organizationNameAlreadyExists: 'An organization with this name already exists, please choose another name',
    emailAddressAlreadyExists: 'There already exists an account with this email address',
    mustBeAValidEmailAdress: 'Please enter a valid email address',
    bothPasswordsMustBeTheSame: `The two password fields don/'t match`,
    alphaNumSpaceOnly: 'Allowed characters: letters, numbers and the following . - _ °',
    alphaNumOnly: 'Allowed characters: letters, numbers, - and _ (no spaces)',
    alphaNumDot: 'Allowed characters: letters, numbers and .',
    orgNameOnly: 'Allowed characters: letters, numbers and -, and the - cannot be at either the beginning or the end',
    objectNameAlreadyExists: 'Duplicate name: There exists already an item with this name',
    atMostCharacters: 'Text too long: The maximum length is {num} characters ',
    appNameAlreadyExists: 'Duplicate name: There exists already an app with this name',
    projectNameAlreadyExists: 'Duplicate name: There exists already a project with this name',
    sfxdataNameAlreadyExists: 'Duplicate name: There exists already an asset with this name',
    formNameAlreadyExists: 'Duplicate name: There exists already an asset with this name',
    mediaNameAlreadyExists: 'Duplicate name: There exists already an asset with this name',
    datasetNameAlreadyExists: 'Duplicate name: There exists already a dataset object with this name',
    materialmapperNameAlreadyExists: 'Duplicate name: There exists already a material mapper object with this name',
    datasourceNameAlreadyExists: 'Duplicate name: There exists already an asset with this name',
    reportNameAlreadyExists: 'Duplicate name: There exists already an asset with this name',
    required: 'This field is mandatory',
    fileTypeNotAllowed: 'This file type can\'t be uploaded. Allowed file extensions: {fileTypes}',
    fileTooBig: 'Your file ({{filesize}}) exceeds the limit of {{maxFilesize}} MB',
    userPassOrNameIsWrong: 'Login failed: the username or password were rejected.',
    userIsBlocked: 'The user is blocked due to too many faulty login tries',
    mustBeNumeric: 'The value must be a number',
    mustBeAValidURL: 'Please enter a valid URL in the format https://www.test.ch',
}